import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { MapPin, Clock, MessageCircle, Mail, Phone, Instagram, Facebook, CheckCircle2 } from 'lucide-react';
import { TikTokIcon } from './TikTokIcon';
import { useLanguage } from '../context/LanguageContext';
type Status = 'idle' | 'submitting' | 'success';
export function Contact() {
  const {
    t
  } = useLanguage();
  const [status, setStatus] = useState<Status>('idle');
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setStatus('submitting');
    setTimeout(() => setStatus('success'), 1200);
  };
  const inputClass = 'w-full px-4 py-3 rounded-xl border border-surface bg-background/50 focus:bg-white focus:ring-2 focus:ring-accent/20 focus:border-accent outline-none transition-colors';
  return <section className="py-24 bg-white relative" data-id="element-60" data-mp="ggkudp1rgv39">
      <div id="contacto" className="absolute -top-24" aria-hidden="true" data-id="element-61" data-mp="giffb3d18n7c"></div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-62" data-mp="bo1hyvet8601">
        <div className="max-w-2xl mb-16" data-id="element-63" data-mp="3jv2xz5n65m5k">
          <span className="text-accent font-medium tracking-wider uppercase text-sm mb-3 block" data-id="element-64" data-mp="3jwcw1uu0uuc7">
            {t('Contacto y reservas', 'Contact & reservations')}
          </span>
          <h2 className="text-3xl md:text-4xl font-serif text-primary mb-4" data-id="element-65" data-mp="3b2hpqjh5yxuz">
            {t('Envíanos tu consulta', 'Send us your inquiry')}
          </h2>
          <p className="text-gray-600 text-lg font-light" data-id="element-66" data-mp="3153dkw29wv8h">
            {t('Contanos las fechas y la cantidad de huéspedes, y te respondemos con disponibilidad y tarifas.', 'Tell us your dates and number of guests, and we will get back to you with availability and rates.')}
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12" data-id="element-67" data-mp="2w6s26gwbyco5">
          {/* Form */}
          <div className="lg:col-span-7 order-2 lg:order-1" data-id="element-68" data-mp="qed5tx6osx0o">
            <div className="bg-white p-8 md:p-10 rounded-2xl shadow-sm border border-surface/60" data-id="element-69" data-mp="uedo5swwpsd0">
              {status === 'success' ? <motion.div initial={{
              opacity: 0,
              scale: 0.96
            }} animate={{
              opacity: 1,
              scale: 1
            }} transition={{
              duration: 0.25,
              ease: [0.23, 1, 0.32, 1]
            }} className="flex flex-col items-center justify-center text-center py-12" role="status" data-id="element-70" data-mp="23d5bemoat893">
                  <div className="w-16 h-16 bg-green-50 text-green-600 rounded-full flex items-center justify-center mb-4" data-id="element-71" data-mp="2m1trmvbu6pej">
                    <CheckCircle2 className="w-8 h-8" data-id="element-72" data-mp="2i1jbwqy8skmh" />
                  </div>
                  <h3 className="text-xl font-medium text-primary mb-2" data-id="element-73" data-mp="2d98blmzlawte">
                    {t('¡Consulta enviada!', 'Inquiry sent!')}
                  </h3>
                  <p className="text-gray-600 max-w-sm" data-id="element-74" data-mp="288knb92qwu2v">
                    {t('Gracias por escribirnos. Te responderemos a la brevedad con toda la información.', 'Thanks for reaching out. We will reply shortly with all the details.')}
                  </p>
                  <button onClick={() => setStatus('idle')} className="mt-8 text-accent hover:text-accent-dark font-medium underline" data-id="element-75" data-mp="3d9k44kyg7pbn">
                    {t('Enviar otra consulta', 'Send another inquiry')}
                  </button>
                </motion.div> : <form onSubmit={handleSubmit} className="space-y-5" data-id="element-76" data-mp="3r8jvw1h9ckc1">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-5" data-id="element-77" data-mp="2ig5fmcl2k2">
                    <div className="space-y-1.5" data-id="element-78" data-mp="p93z7togbj">
                      <label htmlFor="nombre" className="block text-sm font-medium text-gray-700" data-id="element-79" data-mp="4utjksgar6hd">
                        {t('Nombre', 'Name')}*
                      </label>
                      <input type="text" id="nombre" name="nombre" required autoComplete="name" className={inputClass} data-id="element-80" data-mp="dslwxr2gk424" />
                    </div>
                    <div className="space-y-1.5" data-id="element-81" data-mp="ewclcl0zx0ro">
                      <label htmlFor="celular" className="block text-sm font-medium text-gray-700" data-id="element-82" data-mp="ew48gt4vhvgh">
                        {t('Celular', 'Mobile')}*
                      </label>
                      <input type="tel" id="celular" name="celular" required autoComplete="tel" className={inputClass} data-id="element-83" data-mp="3ec0vmt1vdjw5" />
                    </div>
                  </div>

                  <div className="space-y-1.5" data-id="element-84" data-mp="17k021oz5b791">
                    <label htmlFor="correo" className="block text-sm font-medium text-gray-700" data-id="element-85" data-mp="12m6xf0dhqlav">
                      {t('Correo electrónico', 'Email address')}*
                    </label>
                    <input type="email" id="correo" name="correo" required autoComplete="email" className={inputClass} data-id="element-86" data-mp="2pjpp0oty08hw" />
                  </div>

                  <div className="space-y-1.5" data-id="element-87" data-mp="3493vnp64wbtl">
                    <label htmlFor="origen" className="block text-sm font-medium text-gray-700" data-id="element-88" data-mp="389ebdtjqagln">
                      {t('¿Cómo llegaste a nosotros?', 'How did you find us?')}*
                    </label>
                    <select id="origen" name="origen" required defaultValue="" className={inputClass} data-id="element-89" data-mp="2zf9cqnycs0vk">
                      <option value="" disabled data-id="element-90" data-mp="5nppvzgoeji8">
                        {t('Seleccioná una opción', 'Select an option')}
                      </option>
                      <option value="google" data-id="element-91" data-mp="pfylzy2o31w">
                        {t('Búsqueda en Google', 'Google search')}
                      </option>
                      <option value="redes" data-id="element-92" data-mp="3mwd1nl6un4ys">
                        {t('Redes sociales', 'Social media')}
                      </option>
                      <option value="recomendacion" data-id="element-93" data-mp="3ivb21390sqwa">
                        {t('Recomendación', 'Recommendation')}
                      </option>
                      <option value="otro" data-id="element-94" data-mp="394ptamzmu5zn">{t('Otro', 'Other')}</option>
                    </select>
                  </div>

                  <div className="space-y-1.5" data-id="element-95" data-mp="346537ge3h2ox">
                    <label htmlFor="mensaje" className="block text-sm font-medium text-gray-700" data-id="element-96" data-mp="347g5tcvt04eg">
                      {t('Mensaje', 'Message')}*
                    </label>
                    <textarea id="mensaje" name="mensaje" rows={4} required className={`${inputClass} resize-none`} data-id="element-97" data-mp="1an64uprgz68r"></textarea>
                  </div>

                  <button type="submit" disabled={status === 'submitting'} className="w-full bg-accent hover:bg-accent-light text-white py-4 px-6 rounded-xl font-medium whitespace-nowrap transition-colors disabled:opacity-70 disabled:cursor-not-allowed" data-id="element-98" data-mp="1jlric6i33v2o">
                    {status === 'submitting' ? t('Enviando...', 'Sending...') : t('Enviar', 'Send')}
                  </button>
                </form>}
            </div>
          </div>

          {/* Info & WhatsApp */}
          <div className="lg:col-span-5 order-1 lg:order-2 space-y-6" data-id="element-99" data-mp="d78srq9fr7hq">
            <div className="bg-primary text-white p-8 rounded-2xl shadow-lg" data-id="element-100" data-mp="d5fkk6j6cf7m">
              <h3 className="text-2xl font-serif text-white mb-2" data-id="element-101" data-mp="32q3y3ulv9j3o">
                {t('Reservá ahora mismo', 'Book right now')}
              </h3>
              <p className="text-white/80 text-sm mb-6" data-id="element-102" data-mp="3bq0hphtefrrv">
                {t('La forma más rápida de consultar disponibilidad y asegurar tu estadía.', 'The fastest way to check availability and secure your stay.')}
              </p>
              <a href="https://wa.me/5492944727449?text=Hola!%20Me%20gustar%C3%ADa%20consultar%20disponibilidad%20en%20Caba%C3%B1as%20Clarita." target="_blank" rel="noopener noreferrer" className="w-full flex items-center justify-center gap-2 bg-[#25D366] hover:bg-[#20bd5a] text-white py-4 px-6 rounded-xl font-medium whitespace-nowrap transition-colors" data-id="element-103" data-mp="3lm3les3wfygx">
                <MessageCircle className="w-5 h-5" data-id="element-104" data-mp="3b8e7czn9cv6" />
                {t('Consultar por WhatsApp', 'Chat on WhatsApp')}
              </a>
            </div>

            <div className="bg-white p-8 rounded-2xl shadow-sm border border-surface/60" data-id="element-105" data-mp="mueaexf5vcq9">
              <h3 className="text-lg font-serif text-primary mb-6" data-id="element-106" data-mp="rt910ljde5kx">
                {t('Contacto', 'Contact')}
              </h3>

              <ul className="space-y-5" data-id="element-107" data-mp="hwvyqz9rejek">
                <li className="flex gap-4" data-id="element-108" data-mp="hvupn0cb06zh">
                  <Mail className="w-5 h-5 text-accent shrink-0 mt-0.5" data-id="element-109" data-mp="45r82modd1gd" />
                  <div data-id="element-110" data-mp="43o5z49xzhva">
                    <span className="block text-sm font-medium text-gray-900" data-id="element-111" data-mp="8whbhud8iu8f">
                      {t('Correo', 'Email')}
                    </span>
                    <a href="mailto:reservas@cabanasclarita.com" className="text-accent hover:text-accent-dark text-sm transition-colors break-all" data-id="element-112" data-mp="3qeacxclpbtxp">
                      reservas@cabanasclarita.com
                    </a>
                  </div>
                </li>
                <li className="flex gap-4" data-id="element-113" data-mp="3lfp8f0zf2o3g">
                  <Phone className="w-5 h-5 text-accent shrink-0 mt-0.5" data-id="element-114" data-mp="3iptezvr5b9bv" />
                  <div data-id="element-115" data-mp="3nowc8u0vwb9a">
                    <span className="block text-sm font-medium text-gray-900" data-id="element-116" data-mp="3npfrg2z5gljm">
                      {t('Teléfono', 'Phone')}
                    </span>
                    <a href="tel:+5492944727449" className="text-gray-600 hover:text-accent text-sm transition-colors" data-id="element-117" data-mp="39rr8j0on7oh7">
                      (+54) 9 294 4727449
                    </a>
                  </div>
                </li>
                <li className="flex gap-4" data-id="element-118" data-mp="acdqti040vyo">
                  <MapPin className="w-5 h-5 text-accent shrink-0 mt-0.5" data-id="element-119" data-mp="3sp286me6sjx6" />
                  <div data-id="element-120" data-mp="k834kgw50pa">
                    <span className="block text-sm font-medium text-gray-900" data-id="element-121" data-mp="joj8y7ok28m">
                      {t('Dónde estamos', 'Where we are')}
                    </span>
                    <p className="text-gray-600 text-sm" data-id="element-122" data-mp="t0r4q9li984z">
                      {t('Los Notros 861, Dina Huapi, Río Negro · a 15 km de San Carlos de Bariloche', 'Los Notros 861, Dina Huapi, Río Negro · 15 km from San Carlos de Bariloche')}
                    </p>
                  </div>
                </li>
                <li className="flex gap-4" data-id="element-123" data-mp="2nj29xvw97sek">
                  <Clock className="w-5 h-5 text-accent shrink-0 mt-0.5" data-id="element-124" data-mp="2ihd18mwi7qtn" />
                  <div data-id="element-125" data-mp="1usbxve2j35v8">
                    <span className="block text-sm font-medium text-gray-900" data-id="element-126" data-mp="1urimfzsmjs6r">
                      {t('Horarios', 'Hours')}
                    </span>
                    <p className="text-gray-600 text-sm" data-id="element-127" data-mp="1pvbs749lc54n">
                      {t('Check-in a partir de las 14:00 · Check-out 10:00', 'Check-in from 2:00 PM · Check-out 10:00 AM')}
                    </p>
                  </div>
                </li>
              </ul>

              <div className="mt-8 pt-6 border-t border-surface" data-id="element-128" data-mp="3b73fcvy4yspr">
                <span className="block text-sm font-medium text-gray-900 mb-3" data-id="element-129" data-mp="3b8wku7x0j6w6">
                  {t('Síguenos', 'Follow us')}
                </span>
                <div className="flex gap-3" data-id="element-130" data-mp="3n7tovl73dg7h">
                  <a href="https://www.instagram.com/cabaniasclarita/" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full bg-background border border-surface flex items-center justify-center text-primary hover:text-accent hover:border-accent transition-colors" aria-label="Instagram" data-id="element-131" data-mp="3nao6l4yq0mx7">
                    <Instagram className="w-5 h-5" data-id="element-132" data-mp="39gwubotluoxs" />
                  </a>
                  <a href="https://www.facebook.com/p/Caba%C3%B1as-Clarita-100063679114396/" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full bg-background border border-surface flex items-center justify-center text-primary hover:text-accent hover:border-accent transition-colors" aria-label="Facebook" data-id="element-133" data-mp="39flv82b3u5d0">
                    <Facebook className="w-5 h-5" data-id="element-134" data-mp="ywh75kk75zxw" />
                  </a>
                  <a href="https://www.tiktok.com/@cabaasclarita" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full bg-background border border-surface flex items-center justify-center text-primary hover:text-accent hover:border-accent transition-colors" aria-label="TikTok" data-id="element-135" data-mp="tvjoz7z6t5we">
                    <TikTokIcon className="w-5 h-5" data-id="element-136" data-mp="b6msqyk8c3bj" />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}